import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  size?: 'lg' | 'sm';
  tone?: 'light' | 'dark';
};
export function Countdown({
  size = 'lg',
  tone = 'dark'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hrs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'sec'
  }];
  const isLarge = size === 'lg';
  const box = tone === 'dark' ? 'bg-navy-card text-gold border-navy-line' : 'bg-white text-ink border-ice-dark';
  const label = tone === 'dark' ? 'text-white/60' : 'text-ink-muted';
  return <div className="flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-65" data-mp="3259fcuacwvqr">
      {units.map(unit => <div key={unit.label} className={`rounded-xl border text-center tabular-nums ${box} ${isLarge ? 'px-4 py-3 sm:px-6 sm:py-4 min-w-[74px] sm:min-w-[92px]' : 'px-3 py-2 min-w-[58px]'}`} data-id="element-66" data-mp="15bfzm06mkl1f">
          <div className={`font-display font-bold leading-none ${isLarge ? 'text-3xl sm:text-5xl' : 'text-2xl'}`} data-id="element-67" data-mp="szzdxd7r3al3">
            {unit.value}
          </div>
          <div className={`uppercase tracking-widest mt-1 font-bold ${label} ${isLarge ? 'text-[10px]' : 'text-[9px]'}`} data-id="element-68" data-mp="12sevwaj1rz5z">
            {unit.label}
          </div>
        </div>)}
    </div>;
}